<template>
  <div>
    <b-navbar
      id="header"
      toggleable="lg"
      class="header pr-5 pl-0 py-3 tp-background"
    >
      <responsive-sidebar> </responsive-sidebar>

      <b-collapse id="nav-collapse" is-nav class="text-right m-0 p-0">
        <b-col class="m-0 pl-0 py-0 text-center" cols="3">
          <router-link to="/">
            <div class="d-flex justify-content-center">
              <img :src="config.logoAddress" width="120" />
              <div>
                <h3 class="me-2 text-p-first p-fw-bold pt-3 ">
                  {{ config.title }}
                </h3>
              </div>
            </div>
          </router-link>
        </b-col>
        <b-col class="d-flex" dir="rtl" cols="9">
          <div
            v-for="mMenu in menus.filter((menus) => menus.name === 'Main')"
            :key="mMenu.id"
            class="pl-0 pe-5 m-0 d-flex menu-res"
          >
            <span
                    v-for="menu in mMenu.children"
                    :key="menu.id"
            >

            <a
                    v-if="menu.children === null"
                    class="hvr-underline-from-center align-self-center"
                    @click="routeLink(menu)"
            >
              {{ menu.text }}
            </a>
            <b-dropdown
              v-if="menu.children !== null"
              :text="menu.text"
              toggle-class="hvr-underline-from-center px-0 "
              right
              no-caret
              menu-class="mega-menu px-3"
            >
              <b-row>
                <b-col cols="12">
                  <p class="dd-title text-end">
                    <router-link :to="setStaticLink(menu.link)">
                      {{ menu.text }}

                      <img
                        class="ml-1"
                        src="@/assets/images/icons/browser.svg"
                        width="15"
                      />
                    </router-link>
                  </p>
                  <b-row
                    v-for="child in menu.children"
                    :key="child.id"
                    class="mx-0"
                  >
                    <b-button
                      :to="setDynamicLink(child.link)"
                      class="dd-items text-end p-fs-n py-1"
                      v-if="child.isDynamic"
                    >
                      {{ child.text }}
                    </b-button>
                    <b-button
                      :to="setStaticLink(child.link)"
                      class="dd-items text-end p-fs-n py-1"
                      v-else
                    >
                      {{ child.text }}
                    </b-button>
                  </b-row>
                </b-col>
              </b-row>
            </b-dropdown>
            </span>

<!--            <router-link-->
<!--              class="hvr-underline-from-center align-self-center"-->
<!--              :to="{ name: 'UserPanel' }"-->
<!--              v-if="token"-->
<!--            >-->
<!--              {{ label.menu.panel }}-->
<!--            </router-link>-->
<!--            <a-->
<!--              class="mt-2"-->
<!--              @click="logout"-->
<!--              v-b-tooltip.hover-->
<!--              title="خروج"-->
<!--              v-if="token"-->
<!--            >-->
<!--              <b-icon icon="power" variant="danger" />-->
<!--            </a>-->
<!--            <router-link-->
<!--              class="hvr-underline-from-center align-self-center"-->
<!--              :to="{ name: 'UserLogin' }"-->
<!--              v-else-->
<!--            >-->
<!--              {{ label.menu.login }} / {{ label.menu.register }}-->
<!--            </router-link>-->

          </div>

          <!-- change language button -->
          <div class="me-5" v-if="multiLnaguageCheck === 1">
            <b-dropdown
              size="sm"
              v-b-tooltip.hover
              :title="language + ' - ' + label.popup.language"
              toggle-class="no-btn"
              menu-class="language-dd-menu"
              class="pb-2"
              no-caret
            >
              <template #button-content>
                <img
                  src="@/assets/images/flags/en-lang-flag.png"
                  class="img-fluid mt-1 ms-2"
                  width="30px"
                  height="30px"
                  v-if="language === 'En'"
                />
                <img
                  src="@/assets/images/flags/fr-lang-flag.png"
                  class="img-fluid mt-1 ms-2"
                  width="30px"
                  height="30px"
                  v-else-if="language === 'Fr'"
                />
                <img
                  src="@/assets/images/flags/ar-lang-flag.png"
                  class="img-fluid mt-1 ms-2"
                  width="30px"
                  height="30px"
                  v-else-if="language === 'Ar'"
                />
                <img
                  src="@/assets/images/flags/tr-lang-flag.png"
                  class="img-fluid mt-1 ms-2"
                  width="30px"
                  height="30px"
                  v-else-if="language === 'Tr'"
                />
                <img
                  src="@/assets/images/flags/fa-lang-flag.png"
                  class="img-fluid mt-1 ms-2"
                  width="30px"
                  height="30px"
                  v-else
                />
              </template>
              <div>
                <b-dropdown-item
                  class="text-end p-fs-m"
                  @click="changeLanguage('Fa')"
                >
                  <img
                    src="@/assets/images/flags/fa-lang-flag.png"
                    class="img-fluid ms-1"
                    width="25px"
                    height="25px"
                  />
                  {{ label.menu.langFa }}
                </b-dropdown-item>
                <b-dropdown-item
                  class="text-end p-fs-m"
                  @click="changeLanguage('En')"
                >
                  <img
                    src="@/assets/images/flags/en-lang-flag.png"
                    class="img-fluid ms-1"
                    width="25px"
                    height="25px"
                  />
                  {{ label.menu.langEn }}
                </b-dropdown-item>
                <b-dropdown-item
                  class="text-end p-fs-m"
                  @click="changeLanguage('Fr')"
                >
                  <img
                    src="@/assets/images/flags/fr-lang-flag.png"
                    class="img-fluid ms-1"
                    width="25px"
                    height="25px"
                  />
                  {{ label.menu.langFr }}
                </b-dropdown-item>
                <b-dropdown-item
                  class="text-end p-fs-m"
                  @click="changeLanguage('Ar')"
                >
                  <img
                    src="@/assets/images/flags/ar-lang-flag.png"
                    class="img-fluid ms-1"
                    width="25px"
                    height="25px"
                  />
                  {{ label.menu.langAr }}
                </b-dropdown-item>
                <b-dropdown-item
                  class="text-end p-fs-m"
                  @click="changeLanguage('Tr')"
                >
                  <img
                    src="@/assets/images/flags/tr-lang-flag.png"
                    class="img-fluid ms-1"
                    width="25px"
                    height="25px"
                  />
                  {{ label.menu.langTr }}
                </b-dropdown-item>
              </div>
            </b-dropdown>
          </div>
        </b-col>
      </b-collapse>
      <!-- <hr class="line-header" /> -->
    </b-navbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ResponsiveSidebar from "@/containers/TheResponsiveSidebar.vue";
import label from "@/plugins/StaticLabels.js";

export default {
  name: "TheHeader",
  components: {
    ResponsiveSidebar,
  },
  data() {
    return {
      label,
      multiLnaguageCheck: process.env.VUE_APP_MULTI_LANGUAGE,
    };
  },
  computed: {
    ...mapGetters({
      menus: "baseX/menus",
      config: "baseX/config",
      language: "selectedLanguage",
      token: "panelX/token",
    }),
    routeName() {
      return this.$route.name;
    },
  },
  methods: {
    changeLanguage(item) {
      localStorage.setItem("PCMSClientLanguage", item);
      this.$store.commit("setLanguage", item);
      this.$router.push("/");
    },
    setDynamicLink(item) {
      return "/page" + item;
    },
    setStaticLink(item) {
      if (item.startsWith("/", 0)) {
        return item;
      } else {
        return "/" + item;
      }
    },
    routeLink(menu) {
      if (menu.link.indexOf("https") === 0 || menu.link.indexOf("http") === 0) {
        window.open(menu.link, "_blank");
      } else {
        this.$router.push(this.setStaticLink(menu.link));
      }
    },
    logout() {
      this.$store.dispatch("panelX/logout");
    },
  },
  mounted() {
    const header = document.getElementById("header");
    window.onscroll = function () {
      if (window.scrollY >= 5) {
        header.classList.add("fixed-header");
      } else {
        header.classList.remove("fixed-header");
        header.classList.add("header");
      }
    };
  },
  watch: {
    config() {
      const faviconLink = document.querySelector("link[rel='icon']");
      faviconLink.href = this.config.faviconAddress;
    },
  },
  created() {
    var token = window.localStorage.getItem("panelToken");
    this.$store.commit("panelX/setPanelToken", token);
  },
  beforeCreate() {
    this.$store.dispatch("baseX/getMenus");
  },
};
</script>

<style lang="sass">
.language-dd-menu
  width: auto
  border-radius: 10px
  top: 45px
  li
    a
      padding-left: 40px !important
.show > .btn-secondary.dropdown-toggle
  background-color: transparent
  border-color: transparent
</style>
